import { CHANNEL_COLOR, SOURCE_BADGE_LABEL } from "../../lib/mkRules";
import type { InitiativeChannel, InitiativeSource } from "../../types/contract";

interface SourceBadgeProps {
  /**
   * migration前の古いレスポンス・fixtureではフィールド自体が無い可能性があるため
   * null/undefined も受け付ける（無ければ何も表示しない・空バッジを出さない）。
   */
  source: InitiativeSource | null | undefined;
  channel: InitiativeChannel;
}

/**
 * Phase 2（plan-mk2.md §3）: 連携由来の施策に付ける小バッジ（Meta連携／LINE連携／楽天連携）。
 * source が無い（manual・null・undefined）場合は何も表示しない。一覧行・Todayカード・今週終了・
 * 詳細ヘッダーで共用する。
 */
export function SourceBadge({ source, channel }: SourceBadgeProps) {
  if (!source || source === "manual") return null;
  const color = CHANNEL_COLOR[channel];
  return (
    <span
      className="mk-source-badge"
      style={{ color, borderColor: `${color}55`, background: `${color}14` }}
    >
      {SOURCE_BADGE_LABEL[source]}
    </span>
  );
}
